export default  {
    session: {
	get: {
	    url: '/session',
	    method: 'GET',
	    status: {
		success: 'SESSION_GET_SUCCESS'
	    }
	},
	
	create: {
	    url: '/session',
	    method: 'POST',
	    status: {
		success: 'SESSION_CREATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/session',
	    method: 'DELETE',
	    status: {
		success: 'SESSION_DELETE_SUCCESS'
	    }
	}
    },
    users: {
	passwordReset: {
	    url: '/users/rest_password',
	    method: 'PUT',
	    status: {
		success: 'USERS_PASSWORD_RESET_SUCCESS'
	    }
	},
	passwordUpdate: {
	    url: '/users/update_password',
	    method: 'PUT',
	    status: {
		success: 'USERS_PASSWORD_UPDATE_SUCCESS'
	    }
	}
    },
    news: {
	index: {
	    url: '/news',
	    method: 'GET',
	    status: {
		success: 'NEWS_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/news',
	    method: 'POST',
	    status: {
		success: 'NEWS_CREATE_SUCCESS'
	    }
	},

    },
    events: {
	show: {
	    url: '/events/:id',
	    method: 'GET',
	    status: {
		request: 'EVENTS_SHOW_REQUEST',
		success: 'EVENTS_SHOW_SUCCESS'
	    }
	},
	index: {
	    url: '/events',
	    method: 'GET',
	    status: {
		success: 'EVENTS_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/events',
	    method: 'POST',
	    status: {
		success: 'EVENTS_CREATE_SUCCESS'
	    }
	},
	update: {
	    url: '/events/:id',
	    method: 'PUT',
	    status: {
		success: 'EVENTS_UPDATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/events/:id',
	    method: 'DELETE',
	    status: {
		success: 'EVENTS_DELETE_SUCCESS'
	    }
	},

    },
    streamings: {
	show: {
	    url: '/streamings/:id',
	    method: 'GET',
	    status: {
		request: 'STREAMINGS_SHOW_REQUEST',
		success: 'STREAMINGS_SHOW_SUCCESS'
	    }
	},
	index: {
	    url: '/streamings',
	    method: 'GET',
	    status: {
		success: 'STREAMINGS_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/streamings',
	    method: 'POST',
	    status: {
		success: 'STREAMINGS_CREATE_SUCCESS'
	    }
	},
	update: {
	    url: '/streamings/:id',
	    method: 'PUT',
	    status: {
		success: 'STREAMINGS_UPDATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/streamings/:id',
	    method: 'DELETE',
	    status: {
		success: 'STREAMINGS_DELETE_SUCCESS'
	    }
	},

    },
    podcasts: {
	index: {
	    url: '/podcasts',
	    method: 'GET',
	    status: {
		success: 'PODCASTS_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/podcasts',
	    method: 'POST',
	    status: {
		success: 'PODCASTS_CREATE_SUCCESS'
	    }
	},
	update: {
	    url: '/podcasts/:id',
	    method: 'PUT',
	    status: {
		success: 'PODCASTS_UPDATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/podcasts/:id',
	    method: 'DELETE',
	    status: {
		success: 'PODCASTS_DELETE_SUCCESS'
	    }
	},

    },
    pages: {
	index: {
	    url: '/pages',
	    method: 'GET',
	    status: {
		success: 'PAGES_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/pages',
	    method: 'POST',
	    status: {
		success: 'PAGES_CREATE_SUCCESS'
	    }
	},
	update: {
	    url: '/pages/:id',
	    method: 'PUT',
	    status: {
		success: 'PAGES_UPDATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/pages/:id',
	    method: 'DELETE',
	    status: {
		success: 'PAGES_DELETE_SUCCESS'
	    }
	},

    },
    albums: {
	show: {
	    url: '/albums/:id',
	    method: 'GET',
	    status: {
		request: 'ALBUMS_SHOW_REQUEST',
		success: 'ALBUMS_SHOW_SUCCESS'
	    }
	},
	index: {
	    url: '/albums',
	    method: 'GET',
	    status: {
		success: 'ALBUMS_INDEX_SUCCESS'
	    }
	},
	create: {
	    url: '/albums',
	    method: 'POST',
	    status: {
		success: 'ALBUMS_CREATE_SUCCESS'
	    }
	},
	update: {
	    url: '/albums/:id',
	    method: 'PUT',
	    status: {
		success: 'ALBUMS_UPDATE_SUCCESS'
	    }
	},
	delete: {
	    url: '/albums/:id',
	    method: 'DELETE',
	    status: {
		success: 'ALBUMS_DELETE_SUCCESS'
	    }
	},

    },
    photos: {
	delete: {
	    url: '/photos/:id',
	    method: 'DELETE',
	    status: {
		success: 'IMAGES_DELETE_SUCCESS'
	    }
	},
    },
    contact: {
	create: {
	    url: '/contact',
	    method: 'POST',
	    status: {
		success: 'CONTACT_CREATE_SUCCESS'
	    }
	},

    },
}



// WEBPACK FOOTER //
// ./src/utils/restActions.js